import { useLenis } from "../hooks/useLenis";
import { HeaderNav } from "../components/HeaderNav";
import { KineticHero } from "../components/KineticHero";
import { EditorialMarquee } from "../components/EditorialMarquee";
import { ManifestoChapters } from "../components/ManifestoChapters";
import { DeepDiveSections } from "../components/DeepDiveSections";
import { MediatorProfile } from "../components/MediatorProfile";
import { FaqAccordion } from "../components/FaqAccordion";
import { MaterialsSection } from "../components/MaterialsSection";
import { InstagramSection } from "../components/InstagramSection";
import { ContactFormSection } from "../components/ContactFormSection";
import { WhatsAppFloat } from "../components/WhatsAppFloat";
import { FooterSection } from "../components/FooterSection";

export default function LandingPage() {
  useLenis();
  return (
    <div className="min-h-screen bg-paper" data-testid="landing-page">
      <HeaderNav />
      <main>
        <KineticHero />
        <EditorialMarquee />
        <ManifestoChapters />
        <DeepDiveSections />
        <MediatorProfile />
        <FaqAccordion />
        <MaterialsSection />
        <InstagramSection />
        <ContactFormSection />
      </main>
      <FooterSection />
      <WhatsAppFloat />
    </div>
  );
}
